import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  TableContainer,
  Pagination,
} from '@mui/material';
import '../components/css/Users.css';
import colors from '../theme/Colors';
import Navbar from '../components/Navbar';
import { api } from '../helpers/apiRequest';
import CustomSelect from '../components/CustomSelect';
import { toast } from 'react-toastify';
import { pageAccessList } from '../helpers/pageAccessList';

const Customers = () => {
  const [isEditing, setIsEditing] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [showCustomerModal, setShowCustomerModal] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    phone1: '',
    phone2: '',
    phone3: '',
    company_name: '',
    address: '',
    // city: '',
    // country: '',
    fax: '',
    remarks: '',
    balance: 0,
    role: 'customer',
  });
  const [customer, setCustomer] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [rowsPerPage, setRowsPerPage] = React.useState(100);
  const [searchTerm, setSearchTerm] = useState('');
  const [confirmDeleteDialogOpen, setConfirmDeleteDialogOpen] = useState(false);
  const [customerToDelete, setCustomerToDelete] = useState(null);
  
  const [userInfo] = useState(JSON.parse(localStorage.getItem('user')));
  const [accessControl, setAccessControl] = useState({});
  const fetchCurrentUser = async () => {
    try {
      let user = await localStorage.getItem('user');
      user = JSON.parse(user);

      if (user) {
        const res = await api.get(`/users/get/routes?userId=${userInfo?.id}`);
        const accessArray = res.data.message || [];
        // Map route permissions by route key
        const accessMapFromServer = accessArray.reduce((map, item) => {
          map[item.route] = item.allowed;
          return map;
        }, {});

        // Merge with full pageAccessList to ensure all routes are covered
        const accessMap = pageAccessList.reduce((acc, page) => {
          acc[page.key] = accessMapFromServer[page.key] || false;
          return acc;
        }, {});
        console.log("setAccessControl", accessControl);
        setAccessControl(accessMap);
      }
    } catch (error) {
      console.log(error);
    }
  }
  useEffect(() => {
    fetchCurrentUser();
  }, []);
  const fetchCustomer = async () => {
    setLoading(true);
    try {
      let user = await localStorage.getItem('user');
      user = JSON.parse(user);
      const queryParams = new URLSearchParams();
      queryParams.append('page', page);
      queryParams.append('limit', rowsPerPage);
      let response;
      if (searchTerm) {
        response = await api(`users/user-search/${searchTerm}?page=${page}&limit=${rowsPerPage}`);
      }
      else if (user.role === 'merchant') {
        response = await api(`users/merchant/customers/${user.id}?${queryParams.toString()}`);
      } else {
        response = await api(`users/users/role/customer?${queryParams.toString()}`);
      }


      if (response.status) {
        let data = response.data.data || [];

        if (user.role === 'merchant') {
          data = data.map(item => ({
            _id: item.customer._id,
            name: item.customer.name,
            email: item.customer.email,
            phone1: '',
            company_name: '',
            address: '',
            merchant_customer_id: item._id
          }));
        }

        setCustomer(data);
        setTotalPages(Math.ceil(response?.data?.total_count / rowsPerPage));
      } else {
        console.error('Failed to fetch customer:', response.statusText);
      }
    } catch (error) {
      console.error('Error fetching customer:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // const user = JSON.parse(localStorage.getItem('user'));
    // setUserInfo(user);
    
    fetchCustomer();
    setFormData((prev) => ({ ...prev, role: 'customer' }));
    const interval = setInterval(() => {
      fetchCustomer();
    }, 20000);
    return () => clearInterval(interval);

  }, []);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      setPage(1);
      fetchCustomer();
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm]);

  useEffect(() => {
    fetchCustomer();
  }, [rowsPerPage, page]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1); // Reset to first page when changing rows per page
  };
  const handleViewCustomer = (customer) => {
    setSelectedCustomer(customer);
    setShowCustomerModal(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const url = isEditing
        ? `users/update/${formData._id}`
        : `users/admin/create-users`;

      // Prepare the submission data
      const submitData = { ...formData };

      if (isEditing) {
        delete submitData._id;
        delete submitData.__v;
        if (!submitData.password) {
          delete submitData.password;
        }
      }


      // Use PUT for edit and POST for create
      const response = isEditing
        ? await api.put(url, submitData)
        : await api.post(url, submitData);

      if (response.status) {
        toast.success(isEditing ? 'Customer updated successfully!' : 'Customer added successfully!');
        setShowForm(false);
        setFormData({
          name: '',
          email: '',
          password: '',
          phone1: '',
          phone2: '',
          phone3: '',
          company_name: '',
          address: '',
          city: '',
          country: '',
          fax: '',
          remarks: '',
          balance: 0,
          role: 'customer',
        });
        fetchCustomer();
        setIsEditing(false);
      } else {
        throw new Error(response.data?.message || 'Failed to save customer');
      }
    } catch (error) {
      toast.error(error.message || 'Failed to save customer. Please try again.');
      console.error('Error saving customer:', error);
    }
  };

  const handleOpenEditForm = (customer) => {
    setIsEditing(true);
    setFormData(customer);
    setShowForm(true);
  };

  const handleOpenConfirmDeleteDialog = (id) => {
    setCustomerToDelete(id);
    setConfirmDeleteDialogOpen(true);
  };

  const handleDeleteCustomer = async () => {
    try {
      const response = await api.delete(`users/delete/${customerToDelete}`);
      if (response.status) {
        toast.success('Customer deleted successfully!');
        fetchCustomer(); // Refresh the customer table after deletion
      } else {
        throw new Error(response.data?.message || 'Failed to delete customer');
      }
    } catch (error) {
      toast.error(error.message || 'Failed to delete customer. Please try again.');
      console.error('Error deleting customer:', error);
    } finally {
      setConfirmDeleteDialogOpen(false);
      setCustomerToDelete(null);
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', padding: 2 }}>
      <Navbar title="Customers" />
      <Box style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <h2 style={{ textAlign: 'center', color: colors.primary, fontSize: 35 }}>Manage Customers</h2>
        {(userInfo && userInfo?.role==='admin' ||accessControl["manage-customers"]===true ) && (
          <Button
            variant="contained"
            style={{ margin: 8, borderRadius: 50, backgroundColor: colors.primary, fontSize: 15 }}
            onClick={() => setShowForm(true)}
          >
            +
          </Button>
        )}
      </Box>
      {userInfo && userInfo.role !== 'merchant' && (
        <Box sx={{ mb: 2, display: 'flex', justifyContent: 'flex-end' }}>
          <TextField
            label="Search customers"
            variant="outlined"
            size="small"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            sx={{ width: 300 }}
            placeholder="Search by name"
          />
        </Box>
      )}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          flexWrap: 'wrap',
          padding: 2,
        }}
      >

      </Box>

      {/* Conditional rendering based on user role */}
      {userInfo && userInfo.role === 'merchant' ? (
        // Merchant-specific table with simplified columns
        <TableContainer component={Paper} sx={{ boxShadow: 'none' }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ backgroundColor: colors.primary, fontWeight: 'bold' }}>Name</TableCell>
                <TableCell sx={{ backgroundColor: colors.primary, fontWeight: 'bold' }}>Email</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={3} style={{ textAlign: 'center' }}>
                    Loading...
                  </TableCell>
                </TableRow>
              ) : customer.length > 0 ? (
                customer.map((user) => (
                  <TableRow key={user._id}>
                    <TableCell>{user.name}</TableCell>
                    <TableCell>{user.email}</TableCell>

                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={3} style={{ textAlign: 'center' }}>
                    No customers found.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        // Regular admin table with all columns and actions
        <TableContainer component={Paper} sx={{ boxShadow: 'none' }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ backgroundColor: colors.primary, fontWeight: 'bold' }}>Name</TableCell>
                <TableCell sx={{ backgroundColor: colors.primary, fontWeight: 'bold' }}>Email</TableCell>
                <TableCell sx={{ backgroundColor: colors.primary, fontWeight: 'bold' }}>Phone</TableCell>
                <TableCell sx={{ backgroundColor: colors.primary, fontWeight: 'bold' }}>Company</TableCell>
                <TableCell sx={{ backgroundColor: colors.primary, fontWeight: 'bold' }}>Address</TableCell>
                <TableCell sx={{ backgroundColor: colors.primary, fontWeight: 'bold' }}>Merchant</TableCell>

                <TableCell sx={{ backgroundColor: colors.primary, fontWeight: 'bold' }}>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={6} style={{ textAlign: 'center' }}>
                    Loading...
                  </TableCell>
                </TableRow>
              ) : customer.length > 0 ? (
                customer.map((user) => (
                  <TableRow key={user._id}>
                    <TableCell>{user.name}</TableCell>
                    <TableCell>{user.email}</TableCell>
                    <TableCell>{user.phone1}</TableCell>
                    <TableCell>{user.company_name}</TableCell>
                    <TableCell>{user.address}</TableCell>
                    <TableCell>{user?.merchant?.name || ''}</TableCell>
                    <TableCell sx={{ display: 'flex', gap: 1}}>
                      <Button
                        sx={{
                          backgroundColor: colors.primary,
                          color: 'white',
                          borderWidth: 2,
                          borderColor: colors.primary,
                          minWidth: 100, // same width
      textAlign: 'center'
                        }}
                        variant={'outlined'}
                        onClick={() => handleViewCustomer(user)}
                      >
                        View
                      </Button>
                      {(userInfo?.role==='admin'|| accessControl["manage-customers"]===true)&&
                      <>
                      <Button
                        sx={{
                          backgroundColor: colors.primary,
                          color: 'white',
                          borderWidth: 2,
                          marginLeft: 1,
                          minWidth: 100, // same width
      textAlign: 'center',
                          borderColor: colors.primary,
                        }}
                        variant={'outlined'}
                        onClick={() => handleOpenEditForm(user)}
                      >
                        Edit
                      </Button>
                      <Button
                        sx={{
                          backgroundColor: colors.primary,
                          color: 'white',
                          borderWidth: 2,
                          marginLeft: 1,
                          minWidth: 100, // same width
      textAlign: 'center',
                          borderColor: colors.primary,
                        }}
                        variant={'outlined'}
                        onClick={() => handleOpenConfirmDeleteDialog(user._id)}
                      >
                        Delete
                      </Button></>}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={6} style={{ textAlign: 'center' }}>
                    No customers found.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2, mb: 2, alignItems: 'center', gap: 2 }}>
        <Pagination
          count={totalPages}
          page={page}
          onChange={handlePageChange}
          color="primary"
          showFirstButton
          showLastButton
        />
        <CustomSelect
          label="Rows per page"
          value={rowsPerPage}
          onChange={handleChangeRowsPerPage}
          options={[
            // { id: 5, name: '5' },
            // { id: 10, name: '10' },
            // { id: 25, name: '25' },
            // { id: 50, name: '50' },
            { id: 100, name: '100' },
            { id: 200, name: '200' },
            { id: 300, name: '300' },
            { id: 400, name: '400' },
            { id: 500, name: '500' },
          ]}
          sx={{ minWidth: 120 }}
        />
      </Box>

      <Dialog open={showForm} onClose={() => setShowForm(false)}>
        <DialogTitle style={{ color: colors.primary, textAlign: 'center', fontSize: 35 }}>
          {isEditing ? 'Edit Customer' : 'Add Customer'}
        </DialogTitle>
        <DialogContent>
          <form onSubmit={handleSubmit}>
            {Object.keys(formData).map((key) => (
              (key !== '_id' && key !== '__v' && (!isEditing || key !== 'password')) && (
                <TextField
                  key={key}
                  label={key==="actual_password"?"Password":key
                    .replace(/_/g, ' ')
                    .replace(/\b\w/g, (char) => char.toUpperCase())}
                  name={key}
                  value={formData[key]}
                  onChange={handleChange}
                  fullWidth
                  style={{ marginBottom: 16 }}
                  required={!isEditing && ['name', 'email', 'password'].includes(key)}
                  disabled={key === 'role' || (isEditing && key === 'email')}
                  type={key === 'password' ? 'password' : 'text'}
                />
              )
            ))}
            <DialogActions>
              <Button onClick={() => setShowForm(false)} color="secondary">
                Cancel
              </Button>
              <Button type="submit" color="primary">
                {isEditing ? 'Update' : 'Submit'}
              </Button>
            </DialogActions>
          </form>
        </DialogContent>
      </Dialog>

      <Dialog open={showCustomerModal} onClose={() => setShowCustomerModal(false)} fullWidth maxWidth="sm">
        <DialogTitle
          sx={{
            textAlign: 'center',
            color: colors.primary,
            fontSize: 24,
            fontWeight: 'bold',
            pb: 0,
          }}
        >
          Customer Details
        </DialogTitle>
        <DialogContent sx={{ px: 4, py: 2 }}>
          {selectedCustomer ? (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 3,
                mt: 2,
              }}
            >
              {[
                { label: 'Name', value: selectedCustomer.name },
                { label: 'Email', value: selectedCustomer.email },
                { label: 'Phone 1', value: selectedCustomer.phone1 },
                { label: 'Phone 2', value: selectedCustomer.phone2 },
                { label: 'Phone 3', value: selectedCustomer.phone3 },
                userInfo?.role==='admin'&&{label:"Password",value:selectedCustomer?.actual_password},
                { label: 'Address', value: selectedCustomer.address },
                { label: 'City', value: selectedCustomer.city },
                { label: 'Country', value: selectedCustomer.country },
                { label: 'Company Name', value: selectedCustomer.company_name },
                { label: 'Fax', value: selectedCustomer.fax },
                { label: 'Remarks', value: selectedCustomer.remarks },
                { label: 'Balance', value: selectedCustomer.balance },
                { label: 'Role', value: selectedCustomer.role },
              ].map((field, index) => (
                <Box
                  key={index}
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    borderBottom: '1px solid #e0e0e0',
                    pb: 1,
                    fontSize: '1rem',
                    color: 'text.primary',
                  }}
                >
                  <strong>{field.label}:</strong>
                  <span>{field.value}</span>
                </Box>
              ))}
            </Box>
          ) : (
            <Box sx={{ textAlign: 'center', mt: 3, color: 'text.secondary' }}>
              No customer selected.
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center', py: 2 }}>
          <Button
            onClick={() => setShowCustomerModal(false)}
            sx={{
              backgroundColor: colors.primary,
              color: 'white',
              borderColor: colors.primary,
              px: 4,
              borderRadius: '8px'
            }}
            variant="contained"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Confirmation Dialog */}
      <Dialog open={confirmDeleteDialogOpen} onClose={() => setConfirmDeleteDialogOpen(false)}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          <p>Are you sure you want to delete this customer?</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmDeleteDialogOpen(false)} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleDeleteCustomer} color="primary">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Customers;
